module.exports = __webpack_public_path__ + "assets/f8fb06e355e0399b147e84d109b1bc2d.png";